import { EncounterTab } from '../hooks';
import { TabActionBarKind } from '../TabActionBar/TabActionBar';

export const getTabActionBarKind = (
  activeTab: EncounterTab | undefined,
): TabActionBarKind | null => {
  if (!activeTab) {
    return null;
  }

  if (activeTab.kind === 'analytics') {
    return 'analytics';
  }

  if (activeTab.kind === 'transcript') {
    return 'transcript';
  }

  return activeTab.document.requires_approval
    ? 'document-approvable'
    : 'document-readonly';
};
